/* global $, prb_site_vars */

export default function () {
  $('.prb-contact-form').submit(function prbContactFormSubmission(event) {
    event.preventDefault();
    const form = this;

    $.post(prb_site_vars.ajax_url, {
      action: 'prb_contact_form_submission',
      first_name: $(this).find('input[name="first-name"]').val(),
      last_name: $(this).find('input[name="last-name"]').val(),
      email: $(this).find('input[name="email"]').val(),
      remarks: $(this).find('textarea[name="remarks"]').val(),
      type: $(this).find('input[name="type"]:checked').val(),
      affiliation: $(this).find('input[name="affiliation"]').val(),
      nonce: prb_site_vars.contact_form_nonce,
    }, (response) => {
      const formFeedback = $(form).find('.prb-contact-form-feedback');

      // Add the appropiate status.
      formFeedback.removeClass('has-success');
      formFeedback.removeClass('has-error');
      if (response.success) {
        formFeedback.addClass('has-success');
      } else {
        formFeedback.addClass('has-error');
      }

      // Add the text.
      formFeedback.find('.form-control-feedback').html(response.data.message);

      formFeedback.show();
    });
  });
}



// WEBPACK FOOTER //
// ./client/js/article/contactForm.js